module.exports = __webpack_public_path__ + "img/logo.2647f8ba.png";